<template>
    <div>
      <InnerNewsList :dataLink="dataLink"></InnerNewsList>
    </div>
</template>
 
<script>
import InnerNewsList from  './InnerNewsList'
export default {
    components:{
      InnerNewsList
    },
    data(){
        return{
          dataLink: this.phplinkTwo + '/app/index.php?ot=1&id=zhiyuanfengcai'
        }
    }
}
</script>

<style>
</style>